import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchRapidFireLeaderboard } from "../services/rapidFireService";

function normalizePlayer(item = {}, index = 0) {
  return {
    rank: Number(item?.rank || index + 1),
    studentId: Number(item?.student_id || 0),
    name: item?.name || "Student",
    avatar: item?.image_url || "",
    score: Number(item?.score || 0),
    wrongScore: Number(item?.wrong_score || 0),
    isUser: item?.is_current_student || false,
  };
}

function normalizePagination(payload = {}) {
  const pagination = payload?.pagination || {};

  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
  };
}

export function useRapidFireLeaderboard(params = {}, options = {}) {
  return useInfiniteQuery({
    queryKey: ["rapidFireLeaderboard", params],
    queryFn: async ({ pageParam = 1 }) => {
      const { payload } = await fetchRapidFireLeaderboard({
        ...params,
        page: pageParam,
      });
      const pagination = normalizePagination(payload);

      return {
        topThree: (Array.isArray(payload?.top_three) ? payload.top_three : []).map(normalizePlayer),
        players: (Array.isArray(payload?.all_students) ? payload.all_students : []).map(normalizePlayer),
        currentStudent: payload?.current_student ? normalizePlayer(payload.current_student) : null,
        pagination,
      };
    },
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.pagination.currentPage + 1;
      return nextPage <= lastPage.pagination.totalPages ? nextPage : undefined;
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    initialPageParam: 1,
  });
}
